/* eslint-disable prettier/prettier */
import React from "react";
import Text, { TEXT_SIZE } from "@/bit/components/components.text";
import { COLOR_DICTIONARY } from "@gcloud-npm/utils.enums.colors";

const Header6Title = (props) => {
  const { title, theme, textProps, loadingHeaderLocation } = props;
  if (!theme) {
    return null;
  }
  let fontType, size, color;
  switch (theme) {
    case "areaprivada":
      size = TEXT_SIZE.TEXT_PRESET_07;
      color = "white";
      fontType = "font-regular";
      break;
    case "detalle":
      size = TEXT_SIZE.TEXT_PRESET_07;
      color = COLOR_DICTIONARY.MOVISTAR_BLACK;
      fontType = "font-bold";
      break;

    default:
      size = TEXT_SIZE.TEXT_PRESET_06;
      color = COLOR_DICTIONARY.MOVISTAR_BLACK;
      fontType = "font-bold";
  }

  let skeletonClassName = "skeleton loaded";
  if (loadingHeaderLocation) {
    skeletonClassName = "skeleton";
  }

  return (
    <>
      <div className="header6-title" id ="header6-title">
        <div className={theme}>
          <div className="container">
            <Text
              {...textProps}
              text={title}
              fontType={fontType}
              size={size}
              color={color}
            />
            <div className={skeletonClassName} />
          </div>
        </div>
        <style jsx>{`@import "styles/colors.scss";

.header6-title {
  .container{
    .areaprivada {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      background-color: $color--movistar_blue;
    }
    .default {
      :global(.text) {
        text-wrap: balance;
      }
    }
    .skeleton {
      position: absolute;
      top:0px;
      left:12px;
      height:100%;
      width:75vw;
    }
  }
}

@media screen and (min-width: 768px) {
  .header6-title {
    .container{
      .areaprivada {
        padding-top: 0rem;
        padding-bottom: 0rem;
        background-color: $color--movistar_blue;
      }
    }
  }
}
`}</style>
      </div>
    </>
  );
};
export default Header6Title;
